import { FC } from "react";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import __ from "src/utils/Translations";
import useBasePath from "src/utils/hooks/useBasePath";
import Avatar from "src/Components/Avatar";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

interface IEmployeeDetailsProps {
  data: IEmployeeDetails;
  showFk: boolean;
}

const EmployeeDetails: FC<IEmployeeDetailsProps> = ({
  data,
  showFk = false,
}) => {
  const basePath = useBasePath();

  if (!data) return null;

  return (
    <List>
      <ListItem disableGutters>
        <ListItemAvatar>
          <Link to={`${basePath}/employees/${data.employeeId}`}>
            <Avatar
              employeePresence={data.presenceStatus}
              initials={data.initials}
              src={data.avatarUrl}
            />
          </Link>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Typography variant="subtitle2">
              {data.firstName} {data.lastName}
            </Typography>
          }
          secondary={
            <>
              <Typography variant="body2">
                {data.position || __("Brak stanowiska")}
              </Typography>
              {showFk && (
                <Typography variant="body2">
                  <strong>{__("Numer kadrowy")}</strong>: {data.fkNumber}
                </Typography>
              )}
            </>
          }
        />
      </ListItem>
    </List>
  );
};

export default EmployeeDetails;
